import { useState } from "react";
import {
  AppBar,
  Box,
  Toolbar,
  Button,
  ButtonGroup,
  IconButton,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Tooltip,
  Container,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Store as StoreIcon,
  Info as InfoIcon,
  ContactMail as ContactIcon,
} from "@mui/icons-material";

import { Link } from "react-router-dom";

import { useLanguage } from "../context/LanguageContext";
import { useSiteTheme } from "../theme/ThemeContext";

const menuItems = [
  { text: "Gallery", icon: <StoreIcon />, path: "/artworks" },
  { text: "About", icon: <InfoIcon />, path: "/about" },
  { text: "Contact", icon: <ContactIcon />, path: "/contact" },
];

function NavBar() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { language, setLanguage } = useLanguage();

  const { palette } = useSiteTheme();
  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: palette.navbar,
          color: palette.text,
        }}
      >
        <Toolbar disableGutters>
          <Container
            maxWidth="lg"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
            }}
          >
            <Tooltip title="Home">
              <Link to="/" style={{ textDecoration: "none" }}>
                <img
                  // src="/images/byzantine-icon-logo.ico"
                  src="/images/byzantine-icon-logo.webp"
                  alt="Byzantine Icons"
                  style={{ height: "40px" }}
                />
              </Link>
            </Tooltip>
            <IconButton
              color="inherit"
              onClick={() => setIsDrawerOpen(true)}
              sx={{
                display: { xs: "flex", lg: "none" },
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <MenuIcon />
            </IconButton>
            <Box sx={{ display: { xs: "none", lg: "flex" }, gap: 2 }}>
              <Link
                to="/artworks"
                style={{ textDecoration: "none", color: palette.text }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    "&:hover": { color: palette.primary },
                  }}
                >
                  Gallery
                </Typography>
              </Link>

              <Link
                to="/about"
                style={{ textDecoration: "none", color: palette.text }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    "&:hover": { color: palette.primary },
                  }}
                >
                  About
                </Typography>
              </Link>

              <Link
                to="/contact"
                style={{ textDecoration: "none", color: palette.text }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    "&:hover": { color: palette.primary },
                  }}
                >
                  Contact
                </Typography>
              </Link>
            </Box>

            {/* <ThemeSelector /> Used to choose background and text colours*/}

            <ButtonGroup size="small" variant="outlined">
              <Button
                onClick={() => setLanguage("en")}
                sx={{
                  minWidth: "auto",
                  px: 1.25,
                  py: 0.5,
                  borderRadius: 1,

                  bgcolor: language === "en" ? palette.paper : "transparent",

                  color:
                    language === "en" ? palette.navbar : palette.navbarText,

                  "&:hover": {
                    bgcolor:
                      language === "en"
                        ? palette.paper
                        : palette.controlHoverBg,
                  },
                }}
              >
                EN
              </Button>
              <Button
                onClick={() => setLanguage("ro")}
                sx={{
                  minWidth: "auto",
                  px: 1.25,
                  py: 0.5,
                  borderRadius: 1,

                  bgcolor: language === "ro" ? palette.paper : "transparent",

                  color:
                    language === "ro" ? palette.navbar : palette.navbarText,

                  "&:hover": {
                    bgcolor:
                      language === "ro"
                        ? palette.paper
                        : palette.controlHoverBg,
                  },
                }}
              >
                RO
              </Button>
            </ButtonGroup>
          </Container>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="left"
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      >
        <Box
          sx={{
            width: 250,
            pt: 2,
            pb: 2,
          }}
          role="presentation"
          onClick={() => setIsDrawerOpen(false)}
          onKeyDown={() => setIsDrawerOpen(false)}
        >
          <List>
            {menuItems.map((item) => (
              <ListItemButton
                key={item.text}
                component={Link}
                to={item.path}
                sx={{ py: 2 }}
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
}

export default NavBar;
